export default __webpack_public_path__ + "static/media/mysticalbane2.9c09dc17.png";